export default __webpack_public_path__ + "static/media/portfolio-cai-5.05f40204.jpg";